var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDownloadReport(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 24,
    viewBox: "0 0 20 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M19 22.5996L1 22.5996L1 19.5996L19 19.5996L19 22.5996ZM3.4 10.5996L8 10.5996L8 0.999608L12 0.999608L12 10.5996L16.6 10.5996L10 18.2349L3.4 10.5996Z",
    fill: "#329DFF"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadReport);
export default __webpack_public_path__ + "static/media/download_report.77fcd95308d763cba3a4d2369941cd07.svg";
export { ForwardRef as ReactComponent };